<template>
    <v-flex xs6>
        <v-flex md6 class="meeting-tools__links">
            <i class="fas fa-handshake"></i>
            <v-flex tag="strong">{{toolKitConstants.QUICK_MEETING}}</v-flex>
        </v-flex>
    </v-flex>
</template>

<script>
    import { toolKitConstants } from '../ChapterPage/communityCommon.constant';
    
    export default {
        name: "QuickMeetings",
        data: () => {
            return {
                toolKitConstants,
            };
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";

    .meeting-tools {
        &__links {
            cursor: pointer;
            text-align: center;
            width: auto;
            display: block;
            color: $ypo-dark-background-gray;
            padding: 30px 30px;
            transition: 0.3s;
            margin: 0 auto;
            max-width: initial;

            &:hover {
                color: $ypo_blue;
            }

            i {
                display: block;
                font-size: 36px;
            }

            strong {
                font-weight: 500;
                margin-top: 5px;
                display: block;
            }
        }
    }

    .meetings-popup {
        background: $white;

        .v-card__text {
            padding: 0px;
        }

        &__close {
            position: relative;

            .v-btn {
                position: absolute;
                right: -5px;
                z-index: 1;
                top: -20px;
            }
        }

        &__moreitems {
            position: relative;

            &:before {
                content: "";
                height: 100%;
                position: absolute;
                border-left: 1px dashed $ypo-dark-background-gray;
                left: 23px;
            }
        }

        .v-card__title {
            border-radius: 4px 4px 0 0;
            background-color: rgba($ypo_blue, 0.15);
            padding: 15px 10px 15px 50px;
            font-weight: 300;
            font-size: 24px;
            margin-bottom: 20px;
            color: $ypo_blue;
        }

        .date {
            color: $ypo-gold;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            padding: 0px 0 10px 15px;

            i {
                font-size: 20px;
                color: $ypo_blue;
                margin-right: 10px;
                background: $white;
                position: relative;
                z-index: 1;
            }
        }

        .desc {
            position: relative;
            padding: 15px 10px 15px 60px;
            cursor: pointer;
            margin-bottom: 20px;
            transition: all 0.4s ease;

            &:after {
                content: "";
                width: 90%;
                left: 7%;
                bottom: 0;
                height: 2px;
                background: rgba($ypo-blue-secondary, 0.05);
                position: absolute;
            }

            &+.desc {
                margin-top: -20px;
            }

            strong {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                display: block;
                margin-bottom: 10px;
            }

            span {
                color: $black;
                font-family: "Noto Sans";
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;
                border-right: 1px solid $ypo-medium-gray;
                padding-right: 15px;
                margin-right: 15px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            small {
                color: rgba($black, 0.5);
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            .more-info {
                position: absolute;
                right: 10px;
                top: 25px;
                text-align: center;
                color: $ypo-dark-background-gray;
                padding: 0 20px;
                transition: all 0.2s ease;

                i {
                    display: block;
                }

                small {
                    color: $ypo-dark-background-gray;
                    text-transform: uppercase;
                    font-size: 10px;
                }
            }

            &:hover {
                background: rgba($ypo-blue-secondary, 0.05);

                .more-info {
                    opacity: 0;
                    visibility: hidden;
                }

                .desc__actions {
                    opacity: 1;
                    visibility: visible;
                }
            }

            &__actions {
                position: absolute;
                right: 20px;
                top: 25px;
                z-index: 1;
                opacity: 0;
                visibility: hidden;
                transition: all 0.6s ease;

                em {
                    color: $ypo-gray-text;
                    font-size: 10px;
                    font-style: normal;
                    line-height: 14px;
                    text-align: center;
                    display: inline-block;
                    margin: 0 10px;
                    cursor: pointer;

                    i {
                        display: block;
                        font-size: 19px;

                        &.fa-share {
                            color: $ypo-blue-secondary;
                        }

                        &.fa-times-circle {
                            color: $ypo-red;
                        }
                    }
                }
            }
        }
    }

    .meetings-popup {
        background: $white;

        .v-card__text {
            padding: 0px;
        }

        &__moreitems {
            position: relative;

            &:before {
                content: "";
                height: 100%;
                position: absolute;
                border-left: 1px dashed $ypo-dark-background-gray;
                left: 23px;
            }
        }

        .v-card__title {
            border-radius: 4px 4px 0 0;
            background-color: rgba($ypo_blue, 0.15);
            padding: 15px 10px 15px 50px;
            font-weight: 300;
            font-size: 24px;
            margin-bottom: 20px;
            color: $ypo_blue;
        }

        .date {
            color: $ypo-gold;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            padding: 0px 0 10px 15px;

            i {
                font-size: 20px;
                color: $ypo_blue;
                margin-right: 10px;
                background: $white;
                position: relative;
                z-index: 1;
            }
        }

        .desc {
            position: relative;
            padding: 15px 10px 15px 60px;
            cursor: pointer;
            margin-bottom: 20px;
            transition: all 0.4s ease;

            &:after {
                content: "";
                width: 90%;
                left: 7%;
                bottom: 0;
                height: 2px;
                background: rgba($ypo-blue-secondary, 0.05);
                position: absolute;
            }

            &+.desc {
                margin-top: -20px;
            }

            strong {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                display: block;
                margin-bottom: 10px;
            }

            span {
                color: $black;
                font-family: "Noto Sans";
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;
                border-right: 1px solid $ypo-medium-gray;
                padding-right: 15px;
                margin-right: 15px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            small {
                color: rgba($black, 0.5);
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            .more-info {
                position: absolute;
                right: 10px;
                top: 25px;
                text-align: center;
                color: $ypo-dark-background-gray;
                padding: 0 20px;
                transition: all 0.2s ease;

                i {
                    display: block;
                }

                small {
                    color: $ypo-dark-background-gray;
                    text-transform: uppercase;
                    font-size: 10px;
                }
            }

            &:hover {
                background: rgba($ypo-blue-secondary, 0.05);

                .more-info {
                    opacity: 0;
                    visibility: hidden;
                }

                .desc__actions {
                    opacity: 1;
                    visibility: visible;
                }
            }

            &__actions {
                position: absolute;
                right: 20px;
                top: 25px;
                z-index: 1;
                opacity: 0;
                visibility: hidden;
                transition: all 0.6s ease;

                em {
                    color: $ypo-gray-text;
                    font-size: 10px;
                    font-style: normal;
                    line-height: 14px;
                    text-align: center;
                    display: inline-block;
                    margin: 0 10px;
                    cursor: pointer;

                    i {
                        display: block;
                        font-size: 19px;

                        &.fa-share {
                            color: $ypo-blue-secondary;
                        }

                        &.fa-times-circle {
                            color: $ypo-red;
                        }
                    }
                }
            }
        }

        .toolkit-block__details {
            &--header {
                border-bottom: 1px solid rgba(131, 151, 167, 0.2);

                h1 {
                    padding: 30px 20px 20px 20px;
                    float: left;
                    width: 55%;
                }
            }

            .toolkit-search {
                padding-top: 16px;

                .v-text-field {
                    display: inline-block;
                    width: 90%;
                }
            }
        }
    }

    .sample-agendas {
        padding: 0 !important;

        &:hover {
            background: none !important;
        }

        .toolkit-block__items {
            padding-left: 50px;
            padding-right: 70px;

            i.fa-clock {
                top: 2px;
                left: 0;
            }

            i {
                top: 18px;
            }
        }

        &__middle-panel {
            border-right: 1px solid rgba(131, 151, 167, 0.2);
        }

        .time {
            right: 15px;
            top: 18px;

            i {
                color: $ypo-dark-background-gray !important;
                font-size: 13px;
            }

            small {
                font-size: 12px;
                color: $ypo-dark-background-gray !important;
                font-weight: 500;
                padding-left: 22px;
            }
        }

    }

    .thirdSection {
        width: 50%;
    }

    .shortDescription {
        text-overflow: clip;
        white-space: normal !important;
        overflow: hidden;
    }

    .toolkit-block {
        margin-top: -20px;

        &__items {
            color: $ypo_blue;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
            line-height: 22px;
            position: relative;
            transition: 0.3s ease all;
            padding: 15px 0 15px 60px;
            border-bottom: 1px solid rgba($ypo-dark-background-gray, 0.2);
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;

            &:hover {
                background: rgba($ypo-dark-background-gray, 0.2);
            }

            i {
                position: absolute;
                left: 20px;
                top: 30px;
                color: $ypo-cta !important;
                font-size: 16px;
            }

            small {
                display: block;
                color: $ypo-cta;
                font-size: 12px;
                letter-spacing: -0.1px;
                line-height: 20px;
            }
        }

        &__search-input {
            background-color: $white;
            max-width: 322px;
            padding-top: 16px;
        }

        &__content {
            padding: 20px;
            border-bottom: 1px solid rgba($ypo-dark-background-gray, 0.2);

            &--title {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                cursor: pointer;
                line-height: 22px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            &--description {
                display: block;
                color: $ypo-cta;
                font-size: 14px;
                line-height: 20px;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                cursor: pointer;
            }

            &--duration {
                color: $ypo-dark-background-gray;
                font-size: 14px;
                line-height: 20px;

                i {
                    margin-right: 7px;
                }
            }
        }

        &__details {
            border-left: 1px solid rgba($ypo-dark-background-gray, 0.2);

            .details {
                transition: 0.3s all ease;
                padding: 10px 0 10px 20px;
                align-items: center;

                h3 {
                    color: $ypo_blue;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: 24px;
                    margin-bottom: 3px;
                }

                p {
                    color: $ypo-dark-gray;
                    font-family: "Noto Sans";
                    font-size: 14px;
                    letter-spacing: 0.1px;
                    line-height: 18px;
                    margin-bottom: 0;
                }

                .time {
                    color: $ypo-dark-background-gray;
                    font-size: 14px;
                    line-height: 20px;

                    i {
                        margin-right: 7px;
                    }
                }

                &:hover {
                    background: rgba($ypo-dark-background-gray, 0.2);
                }
            }

            &--last-container {
                border-left: 1px solid rgba($ypo-dark-background-gray, 0.2);
                padding-left: 15px;
                width: 50%;
            }
        }

        h1 {
            color: $ypo_blue;
            font-family: 'Noto Sans', sans-serif;
            font-size: 20px;
            font-weight: bold;
            line-height: 26px;
        }
    }

    .popover__title {
        font-size: 24px;
        line-height: 36px;
        text-decoration: none;
        color: rgb(228, 68, 68);
        text-align: center;
        padding: 15px 0;
    }

    .popover__wrapper {
        position: relative;
        margin-top: 1.5rem;
        display: inline-block;
    }

    .popover__content {
        opacity: 0;
        visibility: hidden;
        position: absolute;
        left: -280px;
        transform: translate(0, 10px);
        background-color: #bfbfbf;
        padding: 1.5rem;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
        width: auto;
    }

    .popover__content:before {
        position: absolute;
        z-index: -1;
        content: "";
        right: calc(50% - 10px);
        top: -8px;
        border-style: solid;
        border-width: 0 10px 10px 10px;
        border-color: transparent transparent #bfbfbf transparent;
        transition-duration: 0.3s;
        transition-property: transform;
    }

    .popover__wrapper:hover .popover__content {
        z-index: 10;
        opacity: 1;
        visibility: visible;
        transform: translate(0, -20px);
        transition: all 0.5s cubic-bezier(0.75, -0.02, 0.2, 0.97);
    }

    .popover__message {
        text-align: center;
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";
    @import "../../common/styles/_responsive.scss";

    .toolkit-block {
        &__search {
            margin-top: 7px;
            margin-bottom: 7px;
            color: $white;

            .v-input {
                &__slot {
                    margin: 0;
                    padding: 0px;
                    border: 2px solid $ypo-tile-border !important;
                }

                &__icon--clear {
                    .v-icon {
                        font-size: 14px;
                    }
                }

                input {
                    color: $white !important;
                    margin-top: 5px;
                }

                .v-input__append-inner {
                    margin-top: 8px;
                }

                &--is-focused {
                    background: $ypo_cta-secondary;
                }
            }
        }
    }
</style>
